import * as React from "react";
const SvgFiRrCloudSnow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-snow_svg__a)">
      <path
        fill="#062147"
        d="M10.493 23.6a1 1 0 0 1-.868-.5L9 22.01l-.625 1.09a1 1 0 0 1-1.834-.24 1 1 0 0 1 .1-.76l.633-1.1H6a1 1 0 1 1 0-2h1.274l-.633-1.1a1 1 0 1 1 1.734-1L9 17.99l.625-1.09a1 1 0 0 1 1.733 1l-.633 1.1H12a1 1 0 0 1 0 2h-1.274l.633 1.105a1 1 0 0 1-.866 1.5zM16.5 20H16a1 1 0 1 1 0-2h.5c6.59-.1 7.509-9.506 1.082-10.894a3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.087 6.967a6.2 6.2 0 0 0 .023 2.18 3 3 0 0 1-.962 2.762 3.522 3.522 0 0 0 .153 5.314 1 1 0 1 1-1.258 1.554A5.533 5.533 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.889A7.95 7.95 0 0 1 8.5.137a8.056 8.056 0 0 1 8.734 4.44 1.04 1.04 0 0 0 .742.569C26.76 7.092 25.506 19.818 16.5 20m-1.008-4.4a1 1 0 0 1-.868-.5L14 14.01l-.625 1.09a1 1 0 1 1-1.734-.995L12.273 13H11a1 1 0 1 1 0-2h1.274l-.633-1.1a1.001 1.001 0 0 1 1.734-1L14 9.99l.625-1.09a1 1 0 1 1 1.734.995L15.726 11H17a1 1 0 0 1 0 2h-1.274l.632 1.105a1 1 0 0 1-.866 1.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-snow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudSnow;
